import '../styles/layout.css'

class Logger {
  constructor () {
    this.originalConsole = console

    this.activate()
  }

  activate () {
    this.log = this.originalConsole.log
    this.info = this.originalConsole.info
    this.warn = this.originalConsole.warn
    this.error = this.originalConsole.error
    this.debug = this.originalConsole.debug
    this.trace = this.originalConsole.trace
    this.group = this.originalConsole.group
    this.groupEnd = this.originalConsole.groupEnd
  }

  silence () {
    this.log = () => {}
    this.info = () => {}
    this.warn = () => {}
    this.error = () => {}
    this.debug = () => {}
    this.trace = () => {}
    this.group = () => {}
    this.groupEnd = () => {}
  }
}

const logger = new Logger()

export default function enableUx () {
  logger.log('enableUx')
  logger.silence()

  listenMutations()
}

/**
 * Observes DOM mutations for elements with [data-action] attributes
 * and adds click handlers to toggle .full-screen class
 * @param {Element} element - The root element to observe (defaults to document.body)
 */
function listenMutations (element = document.body) {
  logger.log('listenMutations', element)

  // Set to track already processed elements to avoid duplicate event listeners
  const processedElements = new WeakSet()

  // Function to add click handler to elements with [data-action]
  function addClickHandler (el) {
    if (el.hasAttribute('data-action') && !processedElements.has(el)) {
      processedElements.add(el)

      el.addEventListener('click', (event) => {
        logger.log('click', event)

        event.preventDefault()

        const parentContainer = event.target.closest('wp-card') || event.target.closest('.card')
        if (parentContainer) parentContainer.classList.toggle('full-screen')
      })
    }
  }

  // Function to process all elements with [data-action] in a container
  function processElements (container) {
    const actionElements = container.querySelectorAll('[data-action]')
    actionElements.forEach(addClickHandler)
  }

  // Process existing elements on initialization
  processElements(element)

  // Set up mutation observer
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // Handle added nodes
      logger.log('mutation', mutation)
      if (mutation.type === 'childList') {
        logger.log('childList', mutation)
        mutation.addedNodes.forEach((node) => {
          logger.log('node', node, node.nodeType)
          if (node.nodeType === 1) { // ELEMENT_NODE
            // Check if the added node itself has [data-action]
            addClickHandler(node)
            logger.log('addClickHandler', node)
            // Process any child elements with [data-action]
            processElements(node)
          }
        })
      }

      // Handle attribute changes (in case data-action is added dynamically)
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-action') {
        logger.log('attribute change', mutation)
        addClickHandler(mutation.target)
      }
    })
  })

  // Start observing
  observer.observe(element, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-action']
  })

  // Return observer for potential cleanup
  return observer
}
